import React from 'react';
import styled from 'styled-components';
import { IconPlus } from 'TimeOffList/components/icons';

export const REASON_CHIPS = ['Vacation', 'Sick', 'Personal', 'Tết / Holiday', 'Other'];

interface Props {
  reasonChip: string;
  reasonText: string;
  onPickChip: (chip: string) => void;
  onChangeText: (text: string) => void;
  addHint: string;
  addLabel: string;
  onAdd: () => void;
}

const ReasonSection: React.FC<Props> = ({
  reasonChip, reasonText, onPickChip, onChangeText, addHint, addLabel, onAdd,
}) => (
  <div>
    <SectionLabel>Reason</SectionLabel>
    <Chips>
      {REASON_CHIPS.map(chip => (
        <Chip key={chip} $selected={reasonChip === chip} onClick={() => onPickChip(chip)}>
          {chip}
        </Chip>
      ))}
    </Chips>
    <NoteInput
      value={reasonText}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeText(e.target.value)}
      placeholder="Add a note (optional)"
    />
    <AddRow>
      <span className="hint">{addHint}</span>
      <AddBtn onClick={onAdd}>
        <IconPlus size={16} strokeWidth={2.6} />
        {addLabel}
      </AddBtn>
    </AddRow>
  </div>
);

export default ReasonSection;

const SectionLabel = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--fg-1);
  margin-bottom: 10px;
`;

const Chips = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const Chip = styled.button<{ $selected: boolean }>`
  padding: 7px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  border: ${p => (p.$selected ? '1.5px solid var(--acc)' : '1px solid var(--border-1)')};
  background: ${p => (p.$selected ? 'var(--acc-softer)' : '#fff')};
  color: ${p => (p.$selected ? 'var(--acc)' : '#2C334B')};
`;

const NoteInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 11px 14px;
  border: 1px solid var(--border-1);
  border-radius: var(--r-md);
  font-size: 14px;
  font-family: inherit;
  color: var(--fg-1);
  outline: none;
  &:focus { border-color: var(--border-focus); box-shadow: var(--ring-focus); }
`;

const AddRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  .hint { font-size: 12px; color: var(--fg-3); flex: 1; min-width: 0; }
`;

const AddBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 11px 20px;
  border-radius: var(--r-md);
  border: none;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.03em;
  font-family: inherit;
  flex-shrink: 0;
  background: var(--brand-navy);
  color: #fff;
  cursor: pointer;
  &:hover { background: var(--brand-navy); opacity: 0.9; }
`;
